module.exports = __webpack_public_path__ + "static/media/Privacy-3.d4ebb0c4.png";